import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { assets } from '../data/assets';
import { bonuses, offerBooks, pricing, valueBreakdown } from '../data/content';
import { resizedImage } from '../utils/image';
export function OfferStack() {
  return <section id="purchase" className="bg-sand py-12 md:py-20 px-4" data-id="element-140" data-mp="2kwlh3kacdmmf">
      <div className="max-w-3xl mx-auto" data-id="element-141" data-mp="1x5pnchmbshcj">
        <SectionHeading eyebrow="Todo incluido" title="Llévate la Biblioteca Pausa Propia completa." data-id="element-142" data-mp="1x4en2rs39rq6" />

        <div className="bg-white rounded-2xl border border-sand-deep shadow-soft p-5 md:p-8 max-w-xl mx-auto" data-id="element-143" data-mp="1t2t54s0p6n94">
          <h3 className="font-sans text-[11px] font-bold uppercase tracking-wider text-forest/60" data-id="element-144" data-mp="225khcu1edn1t">
            3 libros principales
          </h3>
          <ul className="mt-2 space-y-2" data-id="element-145" data-mp="1eeyb98ayecug">
            {offerBooks.map(title => <li key={title} className="flex items-start justify-between gap-3 font-sans text-[15px] text-forest" data-id="element-146" data-mp="19hom7trh8375">
                <span className="flex items-start gap-2.5" data-id="element-147" data-mp="14oaffmel4af1">
                  <CheckIcon className="w-4 h-4 mt-1 flex-shrink-0 text-sage-deep" aria-hidden="true" data-id="element-148" data-mp="19nwrvtml9mms" />
                  {title}
                </span>
                <span className="flex-shrink-0 text-xs text-forest/55 mt-1" data-id="element-149" data-mp="1efepq8tbf73j">75 págs.</span>
              </li>)}
          </ul>

          <h3 className="mt-6 font-sans text-[11px] font-bold uppercase tracking-wider text-terracotta-deep" data-id="element-150" data-mp="lq7lqub3dpaw">
            Y además, 2 bonus premium
          </h3>
          <ul className="mt-3 space-y-3" data-id="element-151" data-mp="qpkhk4jxy6pm">
            {bonuses.map(bonus => <li key={bonus.label} className="flex gap-3 rounded-xl bg-ivory border border-sand-deep p-3" data-id="element-152" data-mp="vnm1erp6ya25">
                <img src={resizedImage(assets[bonus.coverKey], 160)} alt={`Portada ${bonus.label}: ${bonus.title}`} className="w-16 h-16 md:w-20 md:h-20 rounded-lg object-cover flex-shrink-0" loading="lazy" decoding="async" width={80} height={80} data-id="element-153" data-mp="zrjy6vr1n8s1" />
                <div className="min-w-0" data-id="element-154" data-mp="70j9kaes7k0h">
                  <div className="flex flex-wrap items-baseline justify-between gap-x-3" data-id="element-155" data-mp="l13p8xpegzpr">
                    <p className="font-sans text-[10px] font-bold uppercase tracking-wider text-plum" data-id="element-156" data-mp="kypvcs6ghtjs">
                      {bonus.label} · 75 páginas
                    </p>
                    <p className="font-sans text-sm" data-id="element-157" data-mp="3oi2edm7p7eb3">
                      <s className="text-forest/50" data-id="element-158" data-mp="3kgqvdzjbxrbv">{pricing.bonusValue}</s>{' '}
                      <span className="font-bold text-sage-deep" data-id="element-159" data-mp="227zbykkr7hq">GRATIS</span>
                    </p>
                  </div>
                  <p className="mt-0.5 font-serif text-base font-bold text-forest leading-snug" data-id="element-160" data-mp="3tgndtjf4ltyh">
                    {bonus.title}
                  </p>
                  <p className="mt-1 font-sans text-[13.5px] text-forest/70 leading-[1.45]" data-id="element-161" data-mp="35p8bvrr9henr">{bonus.text}</p>
                </div>
              </li>)}
          </ul>

          <p className="mt-6 text-center font-sans text-sm font-semibold text-forest" data-id="element-162" data-mp="1g8mihnbk7c3b">
            3 libros + 2 bonus premium ={' '}
            <span className="text-terracotta-deep" data-id="element-163" data-mp="179hisdo9hcpk">375 páginas digitales</span>
          </p>

          <dl className="mt-4 border-t border-sand-deep pt-4 space-y-1 font-sans text-sm text-forest/70" data-id="element-164" data-mp="177obqx9qkqh1">
            {valueBreakdown.map(row => <div key={row.label} className="flex justify-between" data-id="element-165" data-mp="1zz80ewp3qwqf">
                <dt data-id="element-166" data-mp="23zi76bkpxr6c">{row.label}</dt>
                <dd data-id="element-167" data-mp="23ygu61k56ulz">{row.value}</dd>
              </div>)}
            <div className="flex justify-between gap-3 pt-1 font-semibold text-forest" data-id="element-168" data-mp="1q0ihd0lgz68l">
              <dt data-id="element-169" data-mp="1uytr7bbrlgqt">Valor de los recursos por separado</dt>
              <dd data-id="element-170" data-mp="1ux8vhidprrrd">{pricing.separateValue}</dd>
            </div>
          </dl>

          <div className="mt-5 bg-sage-light rounded-xl py-5 px-4 text-center" data-id="element-171" data-mp="ek28jq4f7nup">
            <p className="font-sans text-[11px] font-bold uppercase tracking-wider text-sage-deep" data-id="element-172" data-mp="jk6onf1f2gke">Hoy</p>
            <p className="mt-1 font-sans text-base text-forest/55" data-id="element-173" data-mp="yuliuj8il8zu">
              <s data-id="element-174" data-mp="u33hhu2kx6ec">{pricing.regular}</s>
            </p>
            <p className="font-serif text-5xl md:text-6xl font-bold text-forest leading-none" data-id="element-175" data-mp="u1ab8fvvoo6v">
              {pricing.launch}
            </p>
            <p className="mt-2 font-sans text-[11px] font-bold uppercase tracking-wider text-forest/70" data-id="element-176" data-mp="l258exdaa8ow">
              Pago único
            </p>
          </div>

          <div className="mt-5 text-center" data-hide-sticky data-id="element-177" data-mp="1hrmqkbtgdn7h">
            <CTAButton label={`QUIERO PAUSA PROPIA POR ${pricing.launch} →`} className="md:w-full" data-id="element-178" data-mp="1dqkprqjw133e" />
            <p className="mt-2.5 font-sans text-[12px] md:text-sm text-forest/65" data-id="element-179" data-mp="18qyazcoevesh">
              Acceso inmediato · Sin suscripción · 100% digital
            </p>
          </div>

          <p className="mt-4 font-sans text-[11px] md:text-xs text-forest/55 text-center leading-[1.5]" data-id="element-180" data-mp="3thp3m1xim16l">
            El importe puede visualizarse en la moneda local de tu país según la plataforma y el
            método de pago.
            <br data-id="element-181" data-mp="3eg05l7yw0g1j" />
            Producto digital. No se realizan envíos físicos.
          </p>
        </div>

        <aside className="mt-6 md:mt-8 max-w-xl mx-auto rounded-2xl bg-lavender-light px-5 py-5 md:px-7 text-center" data-id="element-182" data-mp="3jethwx2fu104">
          <p className="font-serif italic text-lg md:text-xl font-bold text-forest" data-id="element-183" data-mp="3obtod93795rr">
            “¿Y si no sé dibujar?”
          </p>
          <p className="mt-1.5 font-sans text-[14.5px] md:text-[15px] text-forest/80 leading-[1.5]" data-id="element-184" data-mp="10ashey6ufey">
            No importa. Puedes empezar con una línea, un color, una mancha, un patrón, una página para
            colorear o un collage. No necesitas experiencia artística.{' '}
            <span className="font-semibold text-forest" data-id="element-185" data-mp="awdtuil7ua0u">Eso es suficiente.</span>
          </p>
        </aside>
      </div>
    </section>;
}